import React from 'react';
import { ArrowRight, Shield, TrendingUp, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

const HeroSection = ({ onGetStarted }) => {
  const navigate = useNavigate();

  return (
    <section className="hero-section" data-testid="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-badge" data-testid="hero-badge">
            <span className="badge-dot"></span>
            <span>500+ clients assisted</span>
          </div>
          <h1 className="hero-title">
            Expert Guidance for
            <span className="hero-highlight"> Every Investment Need.</span>
          </h1>
          <div className="hero-values">
            <span className="hero-value"><Shield size={16} /> Research-Driven</span>
            <span className="hero-separator">|</span>
            <span className="hero-value"><TrendingUp size={16} /> Personalized</span>
            <span className="hero-separator">|</span>
            <span className="hero-value"><Users size={16} /> 15+ Years Expertise</span>
          </div>
          <Button
            className="btn-primary hero-cta-btn"
            data-testid="hero-get-started-btn"
            onClick={onGetStarted}
          >
            Get started now <ArrowRight size={20} />
          </Button>
        </div>
        <div className="hero-stats">
          <div className="stat-card">
            <TrendingUp className="stat-icon" size={32} />
            <h3 className="stat-number">15+</h3>
            <p className="stat-label">Years Experience</p>
          </div>
          <div className="stat-card">
            <Users className="stat-icon" size={32} />
            <h3 className="stat-number">500+</h3>
            <p className="stat-label">Happy Clients</p>
          </div>
          <div className="stat-card">
            <Shield className="stat-icon" size={32} />
            <h3 className="stat-number">100%</h3>
            <p className="stat-label">Trust & Security</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
